// imageSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ImageState {
  selectedImage: string | null;
  error: string;
}

const initialState: ImageState = {
  selectedImage: null,
  error: '',
};

const imageSlice = createSlice({
  name: 'image',
  initialState,
  reducers: {
    setImage: (state, action: PayloadAction<string | null>) => {
      state.selectedImage = action.payload;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
    },
    clearImageState: (state) => {
      state.selectedImage = null;
      state.error = '';
    },
    // Additional action creators if needed
    startUpload: (state) => {
      // Logic for starting upload
    },
    uploadSuccess: (state, action: PayloadAction<string>) => {
      state.selectedImage = action.payload;
      state.error = '';
    },
    uploadFailure: (state, action: PayloadAction<string>) => {
      state.selectedImage = null;
      state.error = action.payload;
    },
  },
});

export const {
  setImage,
  setError,
  clearImageState,
  startUpload,
  uploadSuccess,
  uploadFailure,
} = imageSlice.actions;

export default imageSlice.reducer;
